import { STATUS_TYPE } from '../../../enum';
import { Users } from '../../users/api/interfaces';

export interface FindContactForm {
  type?: string;
  search?: string;
  limit?: number;
  skip?: number;
  isRead?: string; // "true" or "false" as string
}

export interface ContactForm {
  id: string;
  title: string;
  description: string;
  message: string;
  photoUrl: string;
  type: string;
  activeState: boolean;
  advertiseId?: string;
  changesApplied: boolean;
  comment?: string;
  isRead?: boolean; // Computed isRead based on type and changesApplied
  data: {
    email?: string;
    countryCallingCode?: string;
    mobileNumber?: string;
    oldEmail?: string;
    oldMobileNumber?: string;
    oldCountryCallingCode?: string;
  };
  user: Users;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: ContactForm[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
